module.exports = __webpack_public_path__ + "img/brand(1).43b37e23.png";